import { HomeSection } from '../typescript/sections';

export const parseSectionFromHash = (hash: string): HomeSection | null => {
  const normalized = hash.replace(/^#/, '');
  if (
    normalized === 'about' ||
    normalized === 'education' ||
    normalized === 'work-experience' ||
    normalized === 'stack' ||
    normalized === 'recommendations' ||
    normalized === 'contact'
  ) {
    return normalized;
  }
  return null;
};
